import { IAppState } from '../../../AppModulesWrapper';
import { selectAuctionBet } from '../../reducers/v2/promotion/selectors/selectAuctionBet';

export function selectCurrentBet(state: IAppState): number {
  const auctionBet = selectAuctionBet(state);

  return auctionBet.value;
}
